import { requireSessionOrganizationId } from '../../shell/session/sessionOrganization';
import { useSessionStore } from '../../shell/session/store/useSessionStore';
import { findStockInWebCache } from '../../inventory/stock/public-api';
import { patchWebCatalogStockInCache } from './catalogRamSnapshotCache';
import type { ProductMutationOpts } from '../domain/catalogTypes';
import { submitCommand } from '../../sync/core/submitCommand';

/**
 * Actualiza el costo promedio de un producto en la sucursal actual.
 * Crea o actualiza el registro de stock correspondiente.
 */
export async function updateProductAvgCost(
  productId: string,
  avgCost: number,
  opts?: ProductMutationOpts
): Promise<void> {
  await requireSessionOrganizationId();
  const branchId = useSessionStore.getState().currentBranchId;
  if (!branchId) {
    throw new Error('Seleccioná una sucursal para editar el costo.');
  }

  const now = new Date().toISOString();

  const existing = findStockInWebCache(productId, branchId);
  const movementId = crypto.randomUUID();
  const stockId = existing?.id ?? crypto.randomUUID();
  const result = await submitCommand({
    entity: 'stock_adjustment',
    operation: 'insert',
    payload: {
      stockId,
      movementId,
      productId,
      branchId,
      delta: 0,
      reason: 'cost_adjustment',
      unitCost: avgCost,
      performedAt: now,
      performedByUserId: opts?.performedByUserId ?? null,
      originDeviceId: null,
    },
  });
  if (!result.applied) {
    throw new Error(result.ingestError?.trim() || 'No se pudo actualizar el costo en el servidor. Reintentá.');
  }
  patchWebCatalogStockInCache(productId, branchId, existing?.quantity ?? 0, stockId, avgCost);
}
